import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Row, Col, FormGroup, Label, Input } from "reactstrap";

//SimpleBar
import SimpleBar from "simplebar-react";

import { Link } from "react-router-dom";

import Select from "react-select";
import moment from "moment";

import { getMiniVendors, getMiniProductList } from "../../store/Mini/actions";
import { getRFQFilterList } from "../../store/Quotation/actions";
import {
  FiltershideRightSidebar,
  FilterChangeValue,
  FilterSelecteChangeValue,
  SetParams,
  getPurchaseOrderList,
  FilterClear,
} from "../../store/PurchaseOrder/actions";

import "./filtersRightbar.scss";
class FiltertRightbar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.hideFilterRightbar = this.hideFilterRightbar.bind(this);

    this.FilterChangeHandeler = this.FilterChangeHandeler.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.clearFilter = this.clearFilter.bind(this);

    this.poStatus = [
      { value: 1, label: "Pending" },
      { value: 2, label: "Open" },
      { value: 3, label: "IGP" },
      { value: 4, label: "Partially IGP" },
      { value: 5, label: "Closed" },
    ];
  }
  componentDidMount() {
    this.props.getRFQFilterList();
    this.props.getMiniVendors();
  }

  /**
   * Hides the right sidebar
   */
  hideFilterRightbar(e) {
    e.preventDefault();
    this.props.FiltershideRightSidebar();
  }

  FilterChangeHandeler(e) {
    this.props.FilterChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  applyFilter() {
    const adjustEndDate = this.props.params.end_date
      ? moment(this.props.params.end_date).add(1, "days").format("YYYY-MM-DD")
      : "";

    const finalParams = {
      ...this.props.params,
      end_date: adjustEndDate,
      page: 1,
    };
    this.props.SetParams(finalParams);
    this.props.getPurchaseOrderList(finalParams);

    this.props.FiltershideRightSidebar();
  }
  clearFilter() {
    this.props.SetParams({
      ...this.props.params,
      page: 1,
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      vendor: "",
      requestforquotation: "",
      postatus: "",
      poitems__product: "",
    });

    this.props.getPurchaseOrderList({
      ...this.props.params,
      page: 1,
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      vendor: "",
      requestforquotation: "",
      postatus: "",
      poitems__product: "",
    });

    this.props.FilterClear();
    this.props.FiltershideRightSidebar();
  }

  render() {
    return (
      <React.Fragment>
        <div className="filters-right-bar">
          <div className="h-100">
            <div className="rightbar-title px-3 py-4">
              <Link
                to="#"
                onClick={this.hideFilterRightbar}
                className="right-bar-toggle float-right"
              >
                <i className="mdi mdi-close noti-icon"></i>
              </Link>
              <h5 className="m-0">Filters</h5>
            </div>
            <hr className="my-0" />
            <SimpleBar style={{ maxHeight: "100%" }}>
              <div className="px-3 py-4">
                <Row>
                  <Col md={12} className="mb-0">
                    <FormGroup className="mb-0 pb-0">
                      <Label
                        htmlFor="validationFromDate"
                        className="col-form-label"
                      >
                        From Date:
                      </Label>

                      <Input
                        className="mb-0 form-control "
                        type="date"
                        value={this.props.params?.start_date}
                        onChange={this.FilterChangeHandeler}
                        id="CProduct-Name-text-input"
                        name="start_date"
                        placeholder="select Date"
                        max={moment(new Date()).format("YYYY-MM-DD")}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={12} className="mb-0">
                    <FormGroup className="mb-0 pb-0">
                      <Label
                        htmlFor="validationToDate"
                        className="mb-0 col-form-label"
                      >
                        To Date:
                      </Label>

                      <Input
                        className="mb-0 form-control "
                        type="date"
                        value={this.props.params?.end_date}
                        onChange={this.FilterChangeHandeler}
                        id="CProduct-Name-text-input"
                        name="end_date"
                        placeholder="select Date"
                        disabled={
                          this.props.params.start_date === "" ? true : false
                        }
                        min={moment(this.props.params?.start_date).format(
                          "YYYY-MM-DD"
                        )}
                        max={moment(new Date()).format("YYYY-MM-DD")}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup className="mb-0">
                      <Label htmlFor="RFQ-selection" className="col-form-label">
                        RFQ No :
                      </Label>

                      <Select
                        id="RFQ-selection"
                        name="RFQ-selection"
                        classNamePrefix="select2-selection"
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        options={this.props.rfqFilterList.map(
                          (item, index) => ({
                            label: item.code,
                            value: item.id,
                          })
                        )}
                        value={{
                          label: this.props.filterdata?.rfqlabel,
                          value: this.props.params?.requestforquotation,
                        }}
                        onChange={(e) => {
                          this.props.FilterSelecteChangeValue({
                            key: "rfqlabel",
                            label: e.label,
                            key2: "requestforquotation",
                            value: e.value,
                          });
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup className="mb-0">
                      <Label
                        htmlFor="vendorslist-selection"
                        className="col-form-label"
                      >
                        Vendors :
                      </Label>

                      <Select
                        id="vendorslist-selection"
                        name="vendorslist-selection"
                        classNamePrefix="select2-selection"
                        menuPortalTarget={document.body}
                        isSearchable={true}
                        styles={{
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        options={this.props.vendorslist.map((item, index) => ({
                          label: item.name,
                          value: item.id,
                        }))}
                        value={{
                          label: this.props.filterdata?.vendorlabel,
                          value: this.props.params?.vendor,
                        }}
                        onChange={(e) => {
                          this.props.FilterSelecteChangeValue({
                            key: "vendorlabel",
                            label: e.label,
                            key2: "vendor",
                            value: e.value,
                          });
                        }}
                        loading={this.props.vendorsLoading}
                        onInputChange={(inputValue, { action }) => {
                          // Only trigger search on user input, not on select/deselect
                          if (action === "input-change") {
                            this.props.getMiniVendors({
                              ...this.props.vendorParams,
                              page: 1,
                              page_size: 10,
                              search: inputValue,
                            });
                          }
                        }}
                        onMenuOpen={() => {
                          this.props.getMiniVendors({
                            ...this.props.vendorParams,
                            page: 1,
                            page_size: 10,
                            search: "",
                          });
                        }}
                        // onMenuClose={() => {
                        // 	this.props.clearMiniVendors();
                        // }}
                        onMenuScrollToBottom={() => {
                          if (
                            this.props.vendorParams.page <
                            this.props.vendorParams.no_of_pages
                          ) {
                            this.props.getMiniVendors({
                              ...this.props.vendorParams,
                              page: this.props.vendorParams.page + 1,
                              page_size: 10,
                              search: this.props.vendorParams.search || "",
                            });
                          }
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup className="mb-0">
                      <Label htmlFor="products" className="col-form-label">
                        Products :
                      </Label>

                      <Select
                        id="products"
                        name="products"
                        classNamePrefix="select2-selection"
                        menuPortalTarget={document.body}
                        isSearchable={true}
                        styles={{
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        options={this.props.miniProductList.results.map(
                          (item, index) => ({
                            label: `${item.name}-${item.code}`,
                            value: item.id,
                          })
                        )}
                        onInputChange={(inputValue, { action }) => {
                          if (action === "input-change") {
                            this.props.getMiniProductList({
                              ...this.props.miniProductParams,
                              page: 1,
                              page_size: 10,
                              search: inputValue,
                              type: 1,
                            });
                          }
                        }}
                        onMenuOpen={() => {
                          this.props.getMiniProductList({
                            ...this.props.miniProductParams,
                            page: 1,
                            page_size: 10,
                            search: "",
                            type: 1,
                          });
                        }}
                        onMenuScrollToBottom={() => {
                          if (
                            this.props.miniProductParams.page <
                            this.props.miniProductParams.no_of_pages
                          ) {
                            this.props.getMiniProductList({
                              ...this.props.miniProductParams,
                              page: this.props.miniProductParams.page + 1,
                              page_size: 10,
                              search: this.props.miniProductParams.search || "",
                              type: 1,
                            });
                          }
                        }}
                        value={{
                          label: this.props.filterdata?.poitems__product_label,
                          value: this.props.params?.poitems__product,
                        }}
                        onChange={(e) => {
                          this.props.FilterSelecteChangeValue({
                            key: "poitems__product_label",
                            label: e.label,
                            key2: "poitems__product",
                            value: e.value,
                          });
                        }}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={12}>
                    <FormGroup className="mb-0">
                      <Label
                        htmlFor="MRStatus-selection"
                        className="col-form-label"
                      >
                        Status:
                      </Label>

                      <Select
                        id="MRStatus-selection"
                        name="MRStatus-selection"
                        classNamePrefix="select2-selection"
                        isSearchable={true}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        options={this.poStatus}
                        value={{
                          label: this.props.filterdata?.purchaseOrderStatus,
                          value: this.props.params?.sublocation,
                        }}
                        onChange={(e) => {
                          this.props.FilterSelecteChangeValue({
                            key: "purchaseOrderStatus",
                            label: e.label,
                            key2: "postatus",
                            value: e.value,
                          });
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col className="mt-1">
                    <div className="float-right pt-1">
                      <Button
                        type="button"
                        color="light"
                        className="waves-effect waves-light mr-2"
                        onClick={this.clearFilter}
                      >
                        Clear
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        className="waves-effect waves-light"
                        onClick={this.applyFilter}
                      >
                        Apply
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </SimpleBar>
          </div>
        </div>

        <div
          className="filters-right-bar-overlay"
          onClick={this.hideFilterRightbar}
        >
          {" "}
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {
    vendorslist,
    vendorsLoading,
    vendorParams,
    miniProductList,
    miniProductParams,
  } = state.Mini;
  const { rfqFilterList } = state.Quotation;
  const { params, filterdata } = state.PurchaseOrder;

  return {
    rfqFilterList,
    vendorslist,
    vendorsLoading,
    vendorParams,
    params,
    filterdata,
    miniProductList,
    miniProductParams,
  };
};

export default connect(mapStatetoProps, {
  getMiniVendors,
  getRFQFilterList,
  FiltershideRightSidebar,
  FilterChangeValue,
  FilterSelecteChangeValue,
  SetParams,
  getPurchaseOrderList,
  getMiniProductList,
  FilterClear,
})(FiltertRightbar);
